import { Component, Input, OnInit } from '@angular/core';
import { HistoricInstalls } from 'src/app/model/machine/machine.model';
import { MachineService } from 'src/app/services/http/machine/machine.service';

@Component({
  selector: 'app-machine-historic',
  templateUrl: './machine-historic.component.html',
  styleUrls: ['./machine-historic.component.scss']
})
export class MachineHistoricComponent implements OnInit {

  @Input() identifiant !: any;

  public historics!: HistoricInstalls;

  constructor(private service: MachineService) { }

  ngOnInit(): void {

    this.service.getHistoInstall(this.identifiant)
      .subscribe((historics) => {
        this.historics = historics;
        console.log(this.historics);
      });

  }

}
